import React, { useEffect, useState } from 'react';
import { useAppSelector, useAppDispatch } from 'redux/hooks';
import { normalizeSpaces } from 'lib/helpers';
import PlacementActions, { selectNoticeName } from 'redux/placement';
import { TextField } from 'lib/components/TextField';

const MAX_CHAR_LENGTH = 45;

export function useReferenceIdState() {
  const dispatch = useAppDispatch();
  const currentNoticeName = useAppSelector(selectNoticeName);
  const [referenceId, setReferenceId] = useState('');
  const normalizedReferenceId = normalizeSpaces(referenceId);

  useEffect(() => {
    // If the notice name has changed in the store, update the local state
    setReferenceId(currentNoticeName || '');
  }, [currentNoticeName]);

  function saveReferenceId() {
    dispatch(PlacementActions.confirmReferenceId(normalizedReferenceId));
  }

  return {
    referenceId,
    setReferenceId,
    saveReferenceId
  };
}

type ReferenceIdFormProps = {
  referenceId: string;
  setReferenceId: (referenceId: string) => void;
};

export function ReferenceIdForm({
  referenceId,
  setReferenceId
}: ReferenceIdFormProps) {
  const LABELS = {
    FIELD_LABEL: 'What would you like to call this notice?',
    FIELD_NOTE:
      'This name will not appear in the publication. It is used for easy identification or reference in your records.',
    PLACEHOLDER: 'Name, title, or case number for this notice',
    MAXCHARS: `Maximum ${MAX_CHAR_LENGTH} characters allowed.`
  };

  return (
    <div className="max-w-128">
      <TextField
        id="notice-name"
        labelText={LABELS.FIELD_LABEL}
        required
        placeholder={LABELS.PLACEHOLDER}
        maxLength={MAX_CHAR_LENGTH}
        value={referenceId || ''}
        onChange={setReferenceId}
        noteText={LABELS.FIELD_NOTE}
      />
    </div>
  );
}
